import { IFSecure, IProduct } from "../../fetchOrderProducts";

export function isFSecure(product: IProduct): product is IFSecure {
  return "specificationId" in product && product.specificationId === "FSECURE";
}
